/* Chromatic · interacciones: ticker, hero, carrito AJAX, drawer, escalera */
(function () {
  const $ = (s, el) => (el || document).querySelector(s);
  const $$ = (s, el) => Array.from((el || document).querySelectorAll(s));
  /* 5 productos tienen el handle TRADUCIDO en inglés (URL /en/...): product.handle devuelve
     el slug traducido y rompería todos los mapas por handle. Normalizamos al handle canónico. */
  const MC_HANDLE_ALIAS = {
    'pink-pitaya-powder': 'pitaya-rosa',
    'blue-spirulina': 'espirulina-azul',
    'butterfly-pea-flower-powder': 'polvo-flor-guisante-mariposa',
    'mixed-edible-petals': 'petalos-comestibles-mixtos',
    'vanilla-rooibos': 'rooibos-vanilla-powder',
  };
  const mcHandle = (h) => MC_HANDLE_ALIAS[h] || h;
  window.MC_HANDLE_ALIAS = MC_HANDLE_ALIAS;
  const money = (cents) =>
    (cents / 100).toLocaleString(document.documentElement.lang === 'en' ? 'en-IE' : 'es-ES', {
      style: 'currency', currency: window.MC_CURRENCY || 'EUR',
    });

  /* ── ticker rotativo ── */
  const ticker = $('[data-mc-ticker]');
  if (ticker) {
    const msgs = JSON.parse(ticker.dataset.mcTicker || '[]');
    let i = 0;
    setInterval(() => {
      i = (i + 1) % msgs.length;
      const span = ticker.querySelector('span');
      span.style.animation = 'none';
      void span.offsetWidth;
      span.style.animation = '';
      span.textContent = '※ ' + msgs[i] + ' ※';
    }, 5000);
  }

  /* ── hero editorial: takeover de color en toda la página ── */
  const cxHero = $('[data-cx-hero]');
  if (cxHero) {
    const blends = JSON.parse($('[data-cx-blends]', cxHero).textContent);
    const lang = (document.documentElement.lang || 'es').slice(0, 2);
    const pickT = (h, base) => {
      const d = (window.MC_DATA || {})[mcHandle(h)] || {};
      return d[base + '_' + lang] || d[base + '_es'] || '';
    };
    const bandsWrap = $('[data-cx-bands]', cxHero);
    let idx = 0;
    let timer = null;

    blends.forEach((b, i) => {
      const btn = document.createElement('button');
      btn.style.background = b.color;
      btn.style.color = b.fg;
      btn.innerHTML = `<span style="color:${b.fg}">${String(i + 1).padStart(2, '0')} · ${b.short}</span>`;
      btn.addEventListener('click', () => { setActive(i); play(); }); // clic reinicia el ciclo
      bandsWrap.appendChild(btn);
    });

    // autoplay cada 9 s; se pausa al pasar el ratón por encima
    function play() { stop(); timer = setInterval(() => setActive((idx + 1) % blends.length), 5500); }
    function stop() { if (timer) clearInterval(timer); timer = null; }
    cxHero.addEventListener('mouseenter', stop);
    cxHero.addEventListener('mouseleave', play);

    function animateIn() {
      const tin = $('[data-cx-tin]');
      if (tin && tin.animate) tin.animate(
        [{ opacity: 0, transform: 'translateY(34px) rotate(-5deg) scale(.94)' }, { opacity: 1, transform: 'translateY(0) rotate(0) scale(1)' }],
        { duration: 760, easing: 'cubic-bezier(.2,.85,.25,1)' });
      const giant = $('[data-cx-giant]');
      if (giant && giant.animate) giant.animate(
        [{ opacity: 0, transform: 'translateX(-48px)' }, { opacity: 1, transform: 'translateX(0)' }],
        { duration: 640, easing: 'cubic-bezier(.2,.85,.25,1)' });
      ['[data-cx-name]', '[data-cx-tagline]'].forEach((sel, k) => {
        const el = $(sel);
        if (el && el.animate) el.animate(
          [{ opacity: 0, transform: 'translateY(16px)' }, { opacity: 1, transform: 'translateY(0)' }],
          { duration: 520, delay: 110 + k * 90, easing: 'ease-out', fill: 'backwards' });
      });
    }

    function setActive(i) {
      idx = i;
      cxHero.dataset.v = String(i % 4); const b = blends[i];
      document.documentElement.style.setProperty('--cx-bg', b.color);(function(c){c=(c||'').replace('#','');if(c.length>=6){var p=[0,2,4].map(function(i){return Math.round(parseInt(c.substr(i,2),16)*0.6)});document.documentElement.style.setProperty('--mc-deep','rgb('+p.join(',')+')');}})(b.color);
      document.documentElement.style.setProperty('--cx-fg', b.fg);
      document.documentElement.style.setProperty('--cx-fg-line', b.fgLine);
      document.body.style.background = b.color;
      document.body.style.color = b.fg;
      $$('button', bandsWrap).forEach((el, j) => el.dataset.on = j === i ? 'true' : 'false');
      $('[data-cx-giant]').textContent = String(i + 1).padStart(2, '0');
      const numLabel = $('[data-cx-num-label]'); if (numLabel) numLabel.textContent = 'N°' + String(i + 1).padStart(2, '0');
      const notes = $('[data-cx-notes]'); if (notes) notes.textContent = pickT(b.handle, 'notes');
      $('[data-cx-name]').textContent = b.title;
      $('[data-cx-tagline]').textContent = pickT(b.handle, 'tagline') + '.';
      $('[data-cx-tin]').src = b.image;
      $('[data-cx-link]').href = b.url;
      $('[data-cx-price]').textContent = b.price;
      const addBtn = $('[data-cx-add]'); if (addBtn) addBtn.dataset.mcQuickAdd = b.variant;
      /* precio ancla en el hero: tarifa completa tachada + badge EN OFERTA −% */
      const heroSale = $('[data-cx-hero-sale]');
      if (heroSale) {
        if (b.compare && b.pct > 0) {
          heroSale.hidden = false;
          const w = $('[data-cx-hero-was]', heroSale); if (w) w.textContent = b.compare;
          const g = $('[data-cx-hero-bdg]', heroSale); if (g) g.textContent = (g.dataset.label || 'EN OFERTA') + ' −' + b.pct + '%';
        } else heroSale.hidden = true;
      }
      const next = blends[(i + 1) % blends.length];
      $('[data-cx-next]').textContent = next.title;
      animateIn();
    }
    setActive(0);
    play();
  }

  /* ── manifesto: rotación con animaciones variadas ── */
  const manifesto = $('[data-cx-manifesto]');
  if (manifesto) {
    const tags = JSON.parse($('[data-cx-taglines]', manifesto).textContent);
    const line = $('[data-cx-manifesto-line]', manifesto);
    const dotsWrap = $('[data-cx-manifesto-dots]', manifesto);
    const anims = ['cxBlurUp', 'cxSlideRight', 'cxScaleIn'];
    let mIdx = 0;
    tags.forEach((_, i) => {
      const d = document.createElement('button');
      d.addEventListener('click', () => show(i));
      dotsWrap.appendChild(d);
    });
    function show(i) {
      mIdx = i;
      line.style.animation = 'none';
      void line.offsetWidth;
      line.style.animation = `${anims[i % anims.length]} 1.1s cubic-bezier(0.2,0.8,0.2,1) both`;
      line.textContent = tags[i];
      $$('button', dotsWrap).forEach((el, j) => el.dataset.on = j === i ? 'true' : 'false');
    }
    show(0);
    setInterval(() => show((mIdx + 1) % tags.length), 5000);
  }

  /* ── taglines en mosaico de blends ── */
  $$('[data-cx-tile-tagline]').forEach((el) => {
    const h = el.dataset.cxTileTagline;
    const lang = (document.documentElement.lang || 'es').slice(0, 2);
    const d = (window.MC_DATA || {})[h] || {};
    el.textContent = ' - ' + (d['tagline_' + lang] || d['tagline_es'] || '');
  });

  /* ── rainbow 6-pack: añadir los 6 de golpe ── */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-cx-rainbow-add]');
    if (!btn) return;
    e.preventDefault();
    const ids = JSON.parse(btn.dataset.cxRainbowAdd);
    const old = btn.textContent;
    btn.textContent = '…';
    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: ids.map((id) => ({ id, quantity: 1 })) }),
      });
      btn.textContent = '✓';
      document.querySelector('[data-mc-cart-open]')?.click();
    } catch (err) { btn.textContent = '✕'; }
    setTimeout(() => (btn.textContent = old), 1600);
  });

  /* ── construye tu ritual ── */
  const ritual = $('[data-cx-ritual]');
  if (ritual) {
    const groups = JSON.parse($('[data-cx-ritual-data]', ritual).textContent);
    const sel = {};
    const fmt = (c) => (c / 100).toLocaleString('es-ES', { style: 'currency', currency: window.MC_CURRENCY || 'EUR' });

    Object.keys(groups).forEach((key) => {
      const wrap = $(`[data-cx-picker="${key}"] .popts`, ritual);
      groups[key].forEach((opt, i) => {
        const b = document.createElement('button');
        b.innerHTML = `<i style="background:${opt.color}"></i>${opt.name.split(' ').slice(0, 2).join(' ')}`;
        b.addEventListener('click', () => { sel[key] = i; render(); });
        wrap.appendChild(b);
      });
      sel[key] = 0;
    });

    function render() {
      let subtotal = 0;
      const stack = $('[data-cx-ritual-stack]', ritual);
      stack.innerHTML = '';
      Object.keys(groups).forEach((key) => {
        const opts = groups[key];
        if (!opts.length) return;
        const chosen = opts[sel[key]];
        subtotal += chosen.price;
        const img = document.createElement('img');
        img.src = chosen.image;
        img.alt = chosen.name;
        stack.appendChild(img);
        $$(`[data-cx-picker="${key}"] .popts button`, ritual).forEach((b, j) => {
          const on = j === sel[key];
          const o = opts[j];
          b.style.background = on ? o.color : 'transparent';
          b.style.color = on ? o.fg : 'inherit';
          b.style.borderColor = on ? o.color : 'var(--cx-fg-line)';
        });
      });
      const total = subtotal * 0.85;
      $('[data-cx-ritual-subtotal]', ritual).textContent = fmt(subtotal);
      $('[data-cx-ritual-saved]', ritual).textContent = '−' + fmt(subtotal - total);
      $('[data-cx-ritual-total]', ritual).textContent = fmt(total);
    }
    render();

    $('[data-cx-ritual-add]', ritual).addEventListener('click', async (e) => {
      const btn = e.currentTarget;
      const items = Object.keys(groups)
        .filter((k) => groups[k].length)
        .map((k) => ({ id: groups[k][sel[k]].variant, quantity: 1 }));
      const old = btn.textContent;
      btn.textContent = '…';
      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items }),
        });
        btn.textContent = '✓';
        document.querySelector('[data-mc-cart-open]')?.click();
      } catch (err) { btn.textContent = '✕'; }
      setTimeout(() => (btn.textContent = old), 1600);
    });
  }

  /* ── cantidad ± ── */
  document.addEventListener('click', (e) => {
    const dec = e.target.closest('[data-mc-qty-dec]');
    const inc = e.target.closest('[data-mc-qty-inc]');
    if (dec || inc) {
      const wrap = e.target.closest('.mc-qty');
      const input = $('input', wrap);
      const v = Math.max(1, parseInt(input.value || '1') + (inc ? 1 : -1));
      input.value = v;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  /* ── añadir al carrito (AJAX) ── */
  async function addToCart(items) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items }),
    });
    if (!res.ok) throw new Error(await res.text());
    await refreshDrawer(true);
  }

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-mc-product-form]');
    if (!form) return;
    e.preventDefault();
    const btn = $('[type="submit"]', form);
    const old = btn.textContent;
    btn.textContent = '…';
    try {
      const id = $('[name="id"]', form).value;
      const qty = parseInt(($('[name="quantity"]', form) || {}).value || '1');
      // Fuente de verdad: el radio de nuestro selector (Seal u otras apps pueden resetear inputs [name=selling_plan]).
      const subRadio = $('input[name="cx-purchase"]:checked', form);
      const planId = subRadio && subRadio.value !== 'onetime' ? subRadio.value
        : (($('[data-mc-selling-plan]', form) || {}).value || '');
      const item = { id: Number(id), quantity: qty };
      if (planId) item.selling_plan = Number(planId);
      await addToCart([item]);
      btn.textContent = '✓';
    } catch (err) {
      console.error(err);
      btn.textContent = '✕';
    }
    setTimeout(() => (btn.textContent = old), 1400);
  });

  document.addEventListener('click', async (e) => {
    const quick = e.target.closest('[data-mc-quick-add]');
    if (!quick) return;
    e.preventDefault();
    const old = quick.textContent;
    quick.textContent = '…';
    try {
      await addToCart([{ id: Number(quick.dataset.mcQuickAdd), quantity: 1 }]);
      quick.textContent = '✓';
    } catch (err) {
      quick.textContent = '✕';
    }
    setTimeout(() => (quick.textContent = old), 1400);
  });

  /* ── drawer del carrito (diseño: color activo + escalera de pack) ── */
  const drawer = $('#mc-cart-drawer');
  const TIERS = [{ min: 2, pct: 10 }, { min: 3, pct: 15 }, { min: 4, pct: 20 }, { min: 6, pct: 25 }];

  async function refreshDrawer(open) {
    const cart = await fetch('/cart.js').then((r) => r.json());
    window.__mcCartCount = cart.item_count;
    $$('[data-mc-cart-count]').forEach((el) => (el.textContent = cart.item_count));
    const body = $('#mc-cart-drawer-body');
    if (!body) return;

    const count = cart.item_count;
    const tier = TIERS.slice().reverse().find((t) => count >= t.min);
    const pct = tier ? tier.pct : 0;
    const next = TIERS.find((t) => t.min > count);
    // cart.js YA trae el descuento automático aplicado (total_price y final_line_price):
    // usamos las cifras reales de Shopify, nunca recalculamos el % encima (doble descuento).
    const subtotal = cart.original_total_price;
    const discount = cart.total_discount || 0;
    const discounted = cart.total_price;
    const threshold = (window.MC_FREE_SHIPPING || 0) * 100;
    const shipFree = threshold > 0 && discounted >= threshold;
    const shipCost = count === 0 || shipFree ? 0 : (window.MC_SHIPPING_COST || 350);

    let html = '';
    if (count > 0) {
      html += `<div class="cx-drawer__ladder">
        <div class="head"><span class="lbl">${window.MC_T.bundleDisc}</span><span class="big">${pct > 0 ? '−' + pct + '%' : '-'}</span></div>
        <div class="tiers">${TIERS.map((t) => `
          <div class="t ${count >= t.min ? 'hit' : ''}"><div class="p">−${t.pct}%</div><div class="n">${t.min}+ ${window.MC_T.items}</div></div>`).join('')}
        </div>
        ${next ? `<div class="next">${window.MC_T.addMore.replace('{n}', next.min - count).replace('{pct}', next.pct)}</div>`
               : `<div class="next">${window.MC_T.maxUnlocked}</div>`}
      </div>`;
    }

    if (!cart.items.length) {
      html += `<p class="cx-drawer__empty">${window.MC_T.empty}</p>`;
    } else {
      cart.items.forEach((it) => {
        const plan = it.selling_plan_allocation && it.selling_plan_allocation.selling_plan;
        html += `<div class="cx-drawer__line${plan ? ' is-sub' : ''}">
          <img src="${it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/, '_200x$1$2') : ''}" alt="">
          <div class="mid"><div class="title">${it.product_title}</div>
          <div class="variant">${it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title + ' · ' : ''}× ${it.quantity}</div>
          ${plan ? `<div class="sub-tag">🔁 ${plan.name}</div>` : ''}</div>
          <div class="price">${it.original_line_price > it.final_line_price ? `<s style="opacity:.55;font-weight:400;margin-right:6px">${money(it.original_line_price)}</s>` : ''}${money(it.final_line_price)}${plan ? `<span class="per">${window.MC_T.perDelivery || '/ envío'}</span>` : ''}</div>
          <a href="/cart/change?line=${cart.items.indexOf(it) + 1}&quantity=0" class="rm">✕</a>
        </div>`;
      });

      html += `<div class="cx-drawer__totals">
        <div class="row"><span>Subtotal</span><span>${money(subtotal)}</span></div>
        ${discount > 0 ? `<div class="row bold"><span>${window.MC_T.bundleDisc}${pct > 0 ? ' (−' + pct + '%)' : ''}</span><span>−${money(discount)}</span></div>` : ''}
        <div class="row"><span>${window.MC_T.shipping}</span><span>${shipCost === 0 ? window.MC_T.freeWord : money(shipCost)}</span></div>
        ${!shipFree && threshold > 0 ? `<div class="hint">${window.MC_T.shipLeft.replace('{amount}', money(Math.max(0, threshold / (1 - ((TIERS.slice().reverse().find((x) => count + 1 >= x.min) || { pct: 0 }).pct) / 100) - subtotal)))}</div>` : ''}
        <div class="row total"><span>Total</span><span>${money(discounted + shipCost)}</span></div>
        ${pct > 0 ? `<div class="hint">${window.MC_T.bundleNote}</div>` : ''}
        <a class="cx-drawer__checkout" href="/checkout">${window.MC_T.checkout} →</a>
      </div>`;

      /* Si falta poco para el envío gratis, el artículo más barato que cruza la línea va
         PRIMERO y el título lo dice. Convertir una cesta de 2 latas (43,98 €) en 3 artículos
         vale más que ofrecer un batidor de 16,99 € que no cierra un hueco de 5 €. */
      const candidatos = (window.MC_DRAWER_UPSELLS || []).filter(
        (u) => !cart.items.some((it) => it.product_id === u.product_id)
      );
      const faltaEnvio = shipFree ? 0 : Math.max(0, threshold - discounted);
      /* OJO: el descuento por unidades (−10 % a 2 art., −15 % a 3, −20 % a 4, −25 % a 6) se
         aplica al total, y el envío gratis se mide contra el total YA descontado. Así que
         añadir un artículo BAJA el precio y aleja el objetivo: 2 latas + pétalos = 52,97 de
         lista pero 45,02 pagados, y sigue sin llegar a 49. Por eso hay que simular el tramo
         siguiente antes de prometer nada, y por eso las mezclas van primero en la lista. */
      const pctPara = (n) => {
        const t = TIERS.slice().reverse().find((x) => n >= x.min);
        return t ? t.pct : 0;
      };
      const trasAnadir = (precio) => (subtotal + precio) * (1 - pctPara(count + 1) / 100);
      const cierraHueco = faltaEnvio > 0
        ? candidatos.find((u) => trasAnadir(u.price) >= threshold)
        : null;
      /* Lo que falta DE LISTA para llegar (no la diferencia contra el total descontado, que
         engaña: añadir justo esa cantidad no basta porque el descuento crece). */
      const faltaLista = Math.max(0, threshold / (1 - pctPara(count + 1) / 100) - subtotal);
      const upsells = (cierraHueco
        ? [cierraHueco, ...candidatos.filter((u) => u !== cierraHueco)]
        : candidatos).slice(0, 2);
      if (upsells.length) {
        const upLbl = cierraHueco ? (window.MC_T.upsellFree || window.MC_T.ritual) : window.MC_T.ritual;
        html += `<div class="cx-drawer__upsells"><div class="lbl">${upLbl}</div>`;
        upsells.forEach((u) => {
          html += `<div class="cx-drawer__line up">
            <img src="${u.image}" alt="">
            <div class="mid"><div class="title">${u.title}</div><div class="variant">${money(u.price)}</div></div>
            <button data-mc-quick-add="${u.variant_id}">+</button>
          </div>`;
        });
        html += '</div>';
      }
    }
    body.innerHTML = html;

    /* barra flotante de pack */
    let bar = $('#cx-bundle-bar');
    if (count > 0) {
      if (!bar) {
        bar = document.createElement('button');
        bar.id = 'cx-bundle-bar';
        bar.addEventListener('click', () => refreshDrawer(true));
        document.body.appendChild(bar);
      }
      bar.innerHTML = `<strong>${pct > 0 ? '−' + pct + '%' : '-'}</strong><i>│</i><span>${
        next ? window.MC_T.addMore.replace('{n}', next.min - count).replace('{pct}', next.pct) : window.MC_T.maxUnlocked
      }</span>`;
    } else if (bar) {
      bar.remove();
    }

    if (open && drawer) drawer.hidden = false;
  }

  /* ── PDP del diseño ── */
  const pdp = $('[data-cx-pdp]');
  if (pdp) {
    const handle = mcHandle(JSON.parse($('[data-cx-pdp-handle]', pdp).textContent));
    const lang = (document.documentElement.lang || 'es').slice(0, 2);
    const D = (window.MC_DATA || {});
    const pick = (h, base) => { const d = D[mcHandle(h)] || {}; return d[base + '_' + lang] || d[base + '_es'] || ''; };

    /* takeover: el body entero toma el color */
    const cs = getComputedStyle(pdp);
    document.body.style.background = cs.getPropertyValue('--mc-active');
    document.body.style.color = cs.getPropertyValue('--mc-fg');
    document.documentElement.style.setProperty('--cx-bg', cs.getPropertyValue('--mc-active'));
    document.documentElement.style.setProperty('--cx-fg', cs.getPropertyValue('--mc-fg'));
    document.documentElement.style.setProperty('--cx-fg-line', cs.getPropertyValue('--mc-fg-line'));
    if (cs.getPropertyValue('--mc-fg').trim() === '#111') document.body.classList.add('cx-light');

    /* textos del diseño */
    const tag = pick(handle, 'tagline');
    const notes = pick(handle, 'notes');
    $$('[data-cx-pdp-tagline]').forEach((el) => { if (tag) el.textContent = tag + '.'; });
    const t2 = $('[data-cx-pdp-tagline2]'); if (t2) t2.textContent = tag;
    $$('[data-cx-pdp-notes], [data-cx-pdp-notes2]').forEach((el) => (el.textContent = notes));
    const ku = $('[data-cx-pdp-tagline-upper]');
    if (ku && tag) {
      const up = tag.toUpperCase();
      ku.parentElement.innerHTML = `${up} · <em>${up}</em> · ${up} · <em>${up}</em> · ${up}`;
    }

    /* ingredientes numerados */
    let ing = pick(handle, 'ing');
    const ingWrap = $('[data-cx-pdp-ings]', pdp);
    if (!ing && ingWrap) {
      // sin datos curados: sacar la lista de ingredientes del propio body_html
      // (la <ul> sin <strong>, la misma heurística que las bandas de "Sabe lo que bebes")
      const src = $('[data-cx-facts-src]');
      if (src) {
        const uls = Array.from(src.querySelectorAll('details ul')).filter((u) => !u.querySelector('li > strong'));
        if (uls.length) {
          const deE = (t) => { try { return t.replace(/[\p{Extended_Pictographic}️‍]/gu, '').replace(/\s+/g, ' ').trim(); } catch (e) { return t.trim(); } };
          ing = Array.from(uls[0].querySelectorAll('li')).map((li) => deE(li.textContent)).filter(Boolean).join('·');
        }
      }
    }
    if (ing && ingWrap) {
      ingWrap.innerHTML = ing.split(/[,·]/).map((s) => s.trim()).filter(Boolean).map((w, i) =>
        `<div class="ing"><span class="i">${String(i + 1).padStart(2, '0')}</span><span class="w">${w.charAt(0).toUpperCase() + w.slice(1)}</span></div>`
      ).join('');
    } else if (ingWrap) {
      // nada que enseñar (accesorios): fuera la sección entera, nunca el HTML crudo
      const sec = ingWrap.closest('.cx-pdp__ings');
      if (sec) sec.remove();
    }
    const ings2 = $('[data-cx-pdp-ings2]'); if (ings2) ings2.textContent = ing;

    /* pestaña Nutrición: cada ingrediente con su nota (mc-ingredient-notes.js) */
    const notesWrap = $('[data-cx-pdp-ingnotes]', pdp);
    if (notesWrap && window.MC_ING_NOTES && ing) {
      const norm = (s) => s.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
      notesWrap.innerHTML = ing.split(/[,·]/).map((s) => s.trim()).filter(Boolean).map((w) => {
        const nw = norm(w);
        const hit = Object.entries(window.MC_ING_NOTES).find(([k]) => nw.includes(k));
        return `<div class="ingnote"><b>${w.charAt(0).toUpperCase() + w.slice(1)}</b>${hit ? `<span>${hit[1]}</span>` : ''}</div>`;
      }).join('');
    }

    /* selector de tamaño → precio total */
    const fmt = (c) => (c / 100).toLocaleString('es-ES', { style: 'currency', currency: window.MC_CURRENCY || 'EUR' });
    function updateTotal() {
      const sel = $('input[name="cx-size"]:checked', pdp);
      const qty = parseInt(($('[data-cx-pdp-qty]', pdp) || { value: 1 }).value || '1');
      const base = sel ? parseInt(sel.dataset.price) : parseInt(pdp.dataset.basePrice || '0');
      const subSel = $('input[name="cx-purchase"]:checked', pdp);
      const planVal = subSel && subSel.value !== 'onetime' ? subSel.value : '';
      const sp = $('[data-mc-selling-plan]', pdp); if (sp) sp.value = planVal;
      $$('[data-cx-sub] .cx-sub__opt', pdp).forEach((l) => { const r = l.querySelector('input'); l.dataset.on = r && r.checked ? 'true' : 'false'; });
      if (sel) $('[data-mc-variant-id]', pdp).value = sel.value;
      const total = Math.round(base * qty * (planVal ? 0.85 : 1));
      const tot = $('[data-cx-pdp-total]', pdp); if (tot) tot.textContent = fmt(total);
      /* ancla de precio: tarifa completa tachada + badge −% (crece con la suscripción) */
      const wasBox = $('[data-cx-pdp-was]', pdp);
      if (wasBox) {
        const compare = sel ? parseInt(sel.dataset.compare || '0') : parseInt(pdp.dataset.compare || '0');
        const nowUnit = Math.round(base * (planVal ? 0.85 : 1));
        if (compare > nowUnit) {
          wasBox.hidden = false;
          const w = $('[data-cx-was-price]', wasBox); if (w) w.textContent = fmt(compare);
          const n = $('[data-cx-now-price]', wasBox); if (n) n.textContent = fmt(nowUnit);
          const bdg = $('[data-cx-sale-badge]', wasBox);
          if (bdg) bdg.textContent = (bdg.dataset.label || 'EN OFERTA') + ' −' + Math.round((1 - nowUnit / compare) * 100) + '%';
        } else {
          wasBox.hidden = true;
        }
      }
      const corner = $('[data-cx-pdp-corner]', pdp);
      if (corner && sel) corner.innerHTML = sel.nextElementSibling.textContent.split('·')[0].trim() + '<br>' + fmt(total);
    }
    pdp.addEventListener('change', updateTotal);
    updateTotal();

    /* banda cinética + flotación de la lata */
    const kin = $('[data-cx-kinetic]', pdp);
    const tin = $('[data-cx-pdp-img]', pdp);
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      if (kin) kin.style.transform = `translateX(${-y * 0.3}px)`;
      if (tin) tin.style.transform = `rotate(${Math.sin(y * 0.002) * 3}deg) translateY(${Math.sin(y * 0.003) * 12}px)`;
    }, { passive: true });

    /* tabs */
    $$('[data-cx-tab]', pdp).forEach((btn) => btn.addEventListener('click', () => {
      $$('[data-cx-tab]', pdp).forEach((b) => b.classList.toggle('on', b === btn));
      $$('[data-cx-tabpanel]', pdp).forEach((p) => (p.hidden = p.dataset.cxTabpanel !== btn.dataset.cxTab));
    }));

    /* comparador */
    $$('[data-cx-compare-pick]', pdp).forEach((btn) => btn.addEventListener('click', () => {
      const h = btn.dataset.cxComparePick;
      const b = $('[data-cx-compare-b]', pdp);
      b.innerHTML = `<div class="inner" style="background:${btn.dataset.color};color:${btn.dataset.fg}">
        <div class="ab">B</div>
        <div class="name">${btn.dataset.name}</div>
        <div class="tag">${pick(h, 'tagline')}</div>
        <div class="ings">${pick(h, 'ing')}</div>
        <div class="foot"><span>${pick(h, 'notes')}</span><span>${btn.dataset.price}</span></div>
      </div>`;
      $$('[data-cx-compare-pick]', pdp).forEach((x) => (x.style.outline = x === btn ? '3px solid currentColor' : 'none'));
      /* CTA "llévate los dos": A (variante seleccionada) + B → dispara el −10% del pack */
      const cta = $('[data-cx-compare-cta]', pdp);
      if (cta && btn.dataset.variant) {
        cta.hidden = false;
        cta.dataset.variantB = btn.dataset.variant;
        const names = $('[data-cx-both-names]', cta);
        const titleA = ($('.cx-pdp__info .title', pdp)?.textContent || document.title).replace(/\./g, '').trim().split(' ')[0];
        if (names) names.textContent = titleA + ' + ' + btn.dataset.name.split(' ')[0];
      }
    }));
    const bothBtn = $('[data-cx-add-both]', pdp);
    if (bothBtn) bothBtn.addEventListener('click', async () => {
      const cta = $('[data-cx-compare-cta]', pdp);
      const varA = Number(($('[data-mc-variant-id]', pdp) || {}).value || 0);
      const varB = Number(cta?.dataset.variantB || 0);
      if (!varA || !varB) return;
      const old = bothBtn.innerHTML;
      bothBtn.innerHTML = '…';
      try {
        await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: varA, quantity: 1 }, { id: varB, quantity: 1 }] }) });
        bothBtn.innerHTML = '✓';
        if (typeof refreshDrawer === 'function') refreshDrawer(true);
      } catch (e) { bothBtn.innerHTML = '✕'; }
      setTimeout(() => (bothBtn.innerHTML = old), 1800);
    });
  }

  /* ── bandeja "crea tu pack" (tienda) ── */
  const tray = $('[data-cx-tray]');
  if (tray) {
    const opts = JSON.parse($('[data-cx-tray-data]', tray).textContent);
    const slots = [null, null, null];
    const fmt = (c) => (c / 100).toLocaleString('es-ES', { style: 'currency', currency: window.MC_CURRENCY || 'EUR' });
    const TRAY_PCT = 15; // 3 artículos = tramo −15% del descuento automático (Shopify trunca por línea)

    const addersWrap = $('[data-cx-tray-adders]', tray);
    opts.forEach((o, i) => {
      const b = document.createElement('button');
      b.style.background = o.color;
      b.style.color = o.fg;
      b.textContent = '+ ' + o.short;
      b.addEventListener('click', () => {
        const idx = slots.findIndex((s) => s === null);
        if (idx === -1) return;
        slots[idx] = i;
        render();
      });
      addersWrap.appendChild(b);
    });

    function render() {
      const full = slots.every((s) => s !== null);
      slots.forEach((s, i) => {
        const el = $(`[data-cx-slot="${i}"]`, tray);
        if (s === null) {
          el.className = 'slot';
          el.style.background = 'transparent';
          el.style.color = 'inherit';
          el.innerHTML = `<div class="ph"><div class="n">0${i + 1}</div><div class="l">${el.dataset.l || ''}</div></div>`;
        } else {
          const o = opts[s];
          el.className = 'slot filled';
          el.style.background = o.color;
          el.style.color = o.fg;
          el.innerHTML = `<img src="${o.image}" alt=""><div class="sn">${o.short}</div><div class="x">✕</div>`;
          el.onclick = () => { slots[i] = null; el.onclick = null; render(); };
        }
      });
      $$('.adders button', tray).forEach((b) => (b.disabled = full));
      const sum = slots.filter((s) => s !== null).reduce((a, s) => a + opts[s].price, 0);
      const disc = full ? slots.reduce((a, s) => a + Math.floor(opts[s].price * TRAY_PCT / 100), 0) : 0;
      $('[data-cx-tray-count]', tray).textContent = slots.filter((s) => s !== null).length;
      $('[data-cx-tray-price]', tray).textContent = sum ? fmt(sum - disc) : '-';
      const cmp = $('[data-cx-tray-compare]', tray);
      cmp.hidden = !full;
      if (full) cmp.textContent = fmt(sum);
      $('[data-cx-tray-add]', tray).disabled = !full;
    }
    render();

    $('[data-cx-tray-add]', tray).addEventListener('click', async (e) => {
      const btn = e.currentTarget;
      const items = slots.map((s) => ({ id: opts[s].variant, quantity: 1 }));
      btn.textContent = '…';
      try {
        await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items }) });
        slots.fill(null);
        render();
        document.querySelector('[data-mc-cart-open]')?.click();
        btn.textContent = '✓';
      } catch (err) { btn.textContent = '✕'; }
      setTimeout(() => (btn.textContent = btn.dataset.label || 'OK →'), 1600);
    });
  }

  /* ── quiz de 4 preguntas ── */
  const quiz = $('[data-cx-quiz]');
  if (quiz) {
    const blends = JSON.parse($('[data-cx-quiz-blends]', quiz).textContent);
    const byId = Object.fromEntries(blends.map((b) => [b.id, b]));
    const QT = window.CX_QUIZ_I18N || {};
    const Q = [
      { q: QT.q1 || '¿Cómo está tu energía por la mañana?', opts: [
        { l: QT.q1o1 || 'Despierto y eléctrico', c: ['green', 'blue'] },
        { l: QT.q1o2 || 'Lento, necesita empujón', c: ['yellow', 'black'] },
        { l: QT.q1o3 || 'Suave y soñador', c: ['pink', 'white'] }] },
      { q: QT.q2 || 'Elige un clima', opts: [
        { l: QT.q2o1 || 'Luminoso y cálido', c: ['yellow', 'pink'] },
        { l: QT.q2o2 || 'Fresco y claro', c: ['green', 'blue'] },
        { l: QT.q2o3 || 'Gris y acogedor', c: ['black', 'white'] }] },
      { q: QT.q3 || 'Tu inclinación de sabor', opts: [
        { l: QT.q3o1 || 'Terroso y amargo', c: ['green', 'black'] },
        { l: QT.q3o2 || 'Dulce y floral', c: ['pink', 'blue'] },
        { l: QT.q3o3 || 'Cremoso y especiado', c: ['yellow', 'white'] }] },
      { q: QT.q4 || 'Bebes sobre todo por…', opts: [
        { l: QT.q4o1 || 'Concentración', c: ['green', 'black'] },
        { l: QT.q4o2 || 'Calma para pensar', c: ['blue', 'white'] },
        { l: QT.q4o3 || 'Ánimo y disfrute', c: ['yellow', 'pink'] }] },
    ];
    let step = 0;
    let answers = [];
    const lang = (document.documentElement.lang || 'es').slice(0, 2);
    const pickT = (h, base) => { const d = (window.MC_DATA || {})[mcHandle(h)] || {}; return d[base + '_' + lang] || d[base + '_es'] || ''; };

    function renderQ() {
      $('[data-cx-quiz-progress]', quiz).textContent = `${step + 1} / ${Q.length}`;
      $('[data-cx-quiz-q]', quiz).textContent = Q[step].q;
      const wrap = $('[data-cx-quiz-opts]', quiz);
      wrap.innerHTML = '';
      Q[step].opts.forEach((o) => {
        const b = document.createElement('button');
        b.innerHTML = `<div class="dots">${o.c.map((id) => `<i style="background:${(byId[id] || {}).color || '#888'}"></i>`).join('')}</div>${o.l}`;
        b.addEventListener('click', () => {
          answers.push(o);
          step += 1;
          if (step >= Q.length) showResult(); else renderQ();
        });
        wrap.appendChild(b);
      });
    }

    function showResult() {
      const tally = {};
      answers.forEach((a) => a.c.forEach((id) => (tally[id] = (tally[id] || 0) + 1)));
      const top = Object.entries(tally).sort((a, b) => b[1] - a[1])[0]?.[0] || 'green';
      const w = byId[top] || blends[0];
      quiz.dataset.cxWinner = top;
      $('[data-cx-quiz-stage]', quiz).hidden = true;
      const res = $('[data-cx-quiz-result]', quiz);
      res.hidden = false;
      const card = $('[data-cx-quiz-card]', quiz);
      card.style.background = w.color;
      card.style.color = w.fg;
      $('[data-cx-quiz-winner]', quiz).textContent = w.short + '.';
      $('[data-cx-quiz-tagline]', quiz).textContent = pickT(w.handle, 'tagline') + '.';
      $('[data-cx-quiz-tin]', quiz).src = w.image;
      $('[data-cx-quiz-link]', quiz).href = w.url;
      $('[data-cx-quiz-price]', quiz).textContent = w.price;
      $('[data-cx-quiz-add]', quiz).dataset.mcQuickAdd = w.variant;
      document.body.style.background = w.color;
      document.body.style.color = w.fg;
    }

    $('[data-cx-quiz-restart]', quiz)?.addEventListener('click', () => {
      step = 0; answers = [];
      $('[data-cx-quiz-result]', quiz).hidden = true;
      $('[data-cx-quiz-stage]', quiz).hidden = false;
      renderQ();
    });

    /* premio: email → alta (tag quiz + color) → revela MICOLOR15 sin recargar */
    const qForm = $('[data-cx-quiz-form]', quiz);
    if (qForm) qForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const email = qForm.querySelector('input[name="email"]').value;
      const btn = qForm.querySelector('button'); const old = btn.textContent; btn.textContent = '…';
      try {
        const fd = new URLSearchParams();
        fd.set('form_type', 'customer'); fd.set('utf8', '✓');
        fd.set('contact[email]', email);
        fd.set('contact[tags]', 'newsletter,quiz' + (quiz.dataset.cxWinner ? ',color-' + quiz.dataset.cxWinner : ''));
        await fetch('/contact', { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body: fd.toString() });
        if (typeof subscribeKlaviyo === 'function') subscribeKlaviyo(email, 'quiz-' + (quiz.dataset.cxWinner || 'color'));
      } catch (err) { /* revelamos igualmente: el código es genérico */ }
      qForm.hidden = true;
      const code = $('[data-cx-quiz-code]', quiz); if (code) code.hidden = false;
      btn.textContent = old;
    });
    renderQ();
  }

  /* ── alta directa en Klaviyo (lista B2C TmBWiQ) → dispara el Welcome flow de forma fiable ── */
  function subscribeKlaviyo(email, source) {
    if (!email) return;
    try {
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=Wwnesk', {
        method: 'POST', keepalive: true,
        headers: { 'Content-Type': 'application/json', revision: '2025-04-15' },
        body: JSON.stringify({ data: { type: 'subscription',
          attributes: { profile: { data: { type: 'profile', attributes: { email, properties: { source } } } }, custom_source: source },
          relationships: { list: { data: { type: 'list', id: 'TmBWiQ' } } } } }),
      });
    } catch (e) { /* silencioso */ }
  }
  /* todas las formas de newsletter (popup + footer): beacon a Klaviyo sin bloquear el submit nativo */
  $$('form').forEach((f) => {
    const em = f.querySelector('input[name="contact[email]"]');
    /* Horeca/mayorista (decisión D3, 16-10-2026): NO a la lista B2C; la sección horeca-v2 decide (B2B con consentimiento o solo perfil) */
    const tg = f.querySelector('input[name="contact[tags]"]');
    if (tg && /horeca|wholesale/i.test(tg.value || '')) return;
    if (em) f.addEventListener('submit', () => subscribeKlaviyo(em.value, 'newsletter'));
  });

  /* ── popup newsletter (8 s, una vez) ── */
  setTimeout(() => {
    const pop = $('#cx-newsletter-popup');
    if (pop && !localStorage.getItem('mc_nl_seen')) pop.hidden = false;
  }, 8000);

  /* ── exit intent (escritorio, 1×/sesión): con carrito → empuja el siguiente tramo; sin carrito → popup ── */
  document.addEventListener('mouseout', (e) => {
    if (e.clientY > 8 || e.relatedTarget || sessionStorage.getItem('mc_exit')) return;
    sessionStorage.setItem('mc_exit', '1');
    const count = window.__mcCartCount || 0;
    const lang = (document.documentElement.lang || 'es').slice(0, 2);
    if (count > 0) {
      const next = TIERS.find((t) => t.min > count);
      const cur = TIERS.slice().reverse().find((t) => count >= t.min);
      const T = {
        es: { t: '🛒 Tu carrito te espera', more: (n, p) => `Añade ${n} más y llévate −${p}% EXTRA en todo`, max: '¡Tienes −25% Rainbow Saver aplicado!', cta: 'Ver mi carrito', no: 'Seguir mirando' },
        en: { t: '🛒 Your cart is waiting', more: (n, p) => `Add ${n} more and get an EXTRA −${p}% on everything`, max: 'You have −25% Rainbow Saver applied!', cta: 'View my cart', no: 'Keep browsing' },
        fr: { t: '🛒 Votre panier vous attend', more: (n, p) => `Ajoutez-en ${n} et obtenez −${p}% EN PLUS`, max: 'Vous avez −25% Rainbow Saver !', cta: 'Voir mon panier', no: 'Continuer' },
      }[lang] || null;
      const tt = T || { t: '🛒', more: (n, p) => `+${n} → −${p}%`, max: '−25%', cta: 'Cart', no: 'Close' };
      const msg = next ? tt.more(next.min - count, next.pct) : tt.max;
      const ov = document.createElement('div');
      ov.id = 'cx-exit';
      ov.innerHTML = `<div class="box"><button class="x" aria-label="✕">✕</button><div class="t">${tt.t}</div><div class="m">${msg}</div><div class="b"><button class="go">${tt.cta} →</button><button class="stay">${tt.no}</button></div></div>`;
      ov.style.cssText = 'position:fixed;inset:0;background:rgba(10,10,10,.55);z-index:90;display:flex;align-items:center;justify-content:center;padding:20px';
      const st = document.createElement('style');
      st.textContent = '#cx-exit .box{background:#fff;color:#141414;border-radius:22px;padding:34px 36px;max-width:440px;text-align:center;box-shadow:0 30px 80px rgba(0,0,0,.35)}#cx-exit .t{font-family:var(--font-display);font-size:26px;font-weight:600;margin-bottom:8px}#cx-exit .m{font-size:15.5px;margin-bottom:20px}#cx-exit .b{display:flex;gap:10px;justify-content:center;flex-wrap:wrap}#cx-exit .go{background:#141414;color:#fff;border:0;border-radius:999px;padding:14px 26px;font-weight:800;cursor:pointer}#cx-exit .stay{background:transparent;border:1.5px solid #ccc;border-radius:999px;padding:14px 22px;cursor:pointer}#cx-exit .x{position:absolute;margin:-22px 0 0 190px;background:none;border:0;font-size:16px;cursor:pointer;opacity:.5}';
      ov.appendChild(st);
      document.body.appendChild(ov);
      ov.addEventListener('click', (ev) => {
        if (ev.target.closest('.go')) { ov.remove(); refreshDrawer(true); }
        else if (ev.target.closest('.stay') || ev.target.closest('.x') || ev.target === ov) ov.remove();
      });
    } else {
      const pop = $('#cx-newsletter-popup');
      if (pop && !localStorage.getItem('mc_nl_seen')) pop.hidden = false;
    }
  });
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-cx-nl-close]')) {
      const pop = $('#cx-newsletter-popup');
      if (pop) pop.hidden = true;
      localStorage.setItem('mc_nl_seen', '1');
    }
    if (e.target.closest('[data-cx-mobile-open]')) { const m = $('[data-cx-mobile-menu]'); if (m) m.hidden = false; }
    if (e.target.closest('[data-cx-mobile-close]') || e.target.closest('[data-cx-mobile-menu] a')) { const m = $('[data-cx-mobile-menu]'); if (m) m.hidden = true; }
  });

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-mc-cart-open]')) {
      e.preventDefault();
      refreshDrawer(true);
    }
    if (e.target.closest('[data-mc-cart-close]') && drawer) drawer.hidden = true;
  });

  refreshDrawer(false);
})();
